var React = require('react');

function DropDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.60371 0.514705C2.80386 0.254701 3.19597 0.254701 3.39612 0.514705L5.84433 3.69503C6.09743 4.02381 5.86304 4.50002 5.44813 4.50002H0.551702C0.136782 4.50002 -0.0975992 4.02381 0.155499 3.69503L2.60371 0.514705Z","fill":"#9CA3AF","key":0}),React.createElement("path",{"d":"M2.60371 11.4853C2.80386 11.7453 3.19597 11.7453 3.39612 11.4853L5.84433 8.30502C6.09743 7.97623 5.86304 7.50002 5.44813 7.50002H0.551702C0.136782 7.50002 -0.0975992 7.97623 0.155499 8.30502L2.60371 11.4853Z","fill":"#9CA3AF","key":1})]);
}

DropDown.defaultProps = {"width":"6","height":"12","viewBox":"0 0 6 12","fill":"none"};

module.exports = DropDown;

DropDown.default = DropDown;
